import { render, staticRenderFns } from "./ActionButtonForm.vue?vue&type=template&id=31c8482b"
import script from "./ActionButtonForm.vue?vue&type=script&lang=js"
export * from "./ActionButtonForm.vue?vue&type=script&lang=js"
import style0 from "./ActionButtonForm.vue?vue&type=style&index=0&id=31c8482b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports